import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useStyles from "./application-state.style";
import checkIcon from "@iconify/icons-mdi/check";
import checkBoldIcon from "@iconify/icons-mdi/check-bold";
import closeIcon from "@iconify/icons-mdi/close";
import exclamationIcon from "@iconify/icons-mdi/exclamation";
import { InlineIcon } from "@iconify/react";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

// Define the props type
interface MyTaxApplicationStateProps {
  label: "K" | "V" | "T" | "E"; // Restrict the type to match iconMap keys
}

export const MyTaxApplicationState = ({
  label,
}: MyTaxApplicationStateProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useOcIsMobile();

  const getColor = (label: string) => {
    switch (label) {
      case "K":
        return "#F3AA18";
      case "E":
        return "#2FA84F";
      case "T":
        return "#5E6366";
      case "V":
        return theme.palette.primary.main;

      default:
        return "white";
    }
  };

  const iconMap = {
    K: exclamationIcon,
    V: closeIcon,
    T: checkBoldIcon,
    E: checkIcon,
  };

  const iconColor = getColor(label);
  const IconComponent = iconMap[label] || null; // Ensure fallback for unexpected cases
  const classes = useStyles({ borderColor: getColor(label), isMobile });

  return (
    <Box display="flex" flexDirection="row" justifyContent="center">
      {isMobile && IconComponent && (
        <InlineIcon
          icon={IconComponent}
          className={classes.text}
          width="24px"
          style={{
            color: iconColor,
            cursor: "pointer",
          }}
        />
      )}
      {!isMobile && (
        <Typography
          className={classes.text}
          variant="body2"
          color={theme.palette.gray80.main}
        >
          {t(`MY_TAX_STATE_${label}`)}
        </Typography>
      )}
    </Box>
  );
};

export default MyTaxApplicationState;
